<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <LmComponentLoading v-if="isLoading" fixed />
    <LmBreadcrumb v-if="showBreadcrumb" />
    <h4>Nuevo Remito</h4>
    <LmForm ref="lmFormRef">
      <div class="row">
        <LmDate
          class="col-12 col-lg-6"
          v-model="form.fechaDesde"
          :v="$v.form.fechaDesde"
          label="Fecha Desde"
          id="fechaDesde"
          :config="lmDateConfigFrom"
          placeholder="Fecha Desde"
          />
        <LmDate
          class="col-12 col-lg-6"
          v-model="form.fechaHasta"
          :v="$v.form.fechaHasta"
          label="Fecha Hasta"
          id="fechaHasta"
          :config="lmDateConfigUpTo"
          placeholder="Fecha Hasta"
          />
        <LmSuperPowerSelect
          class="col-12 col-lg-6"
          :data="lmSuperPowerSelects.oficina.selectOptions"
          :tbColumns="lmSuperPowerSelects.oficina.tbColumns"
          label="Oficina Origen"
          title="Oficina Origen"
          placeholder="Oficina Origen"
          @values="updateOficinaOrigen"
          :v="$v.form.oficinaOrigen"
          :model="sanitizeModel(form.idOficinaOrigen)"
        />
        <LmSuperPowerSelect
          class="col-12 col-lg-6"
          :data="lmSuperPowerSelects.oficina.selectOptions"
          :tbColumns="lmSuperPowerSelects.oficina.tbColumns"
          label="Oficina Destino"
          title="Oficina Destino"
          placeholder="Oficina Destino"
          @values="updateOficinaDestino"
          :v="$v.form.oficinaDestino"
        />
      </div>
      <h4>Expedientes a Incluir en el Remito</h4>
      <LmTableCustom
        :key="componentKey"
        :order = order
        :orderBySetting = orderBySetting
        :searchOnFields = searchOnFields
        :perPageSetting = perPageSetting
        :itemsPerPage = defaultItemsPerPage
        :limitExportFromClient = limitExportFromClient
        :apiCallPath = apiCallPath
        :highlight = highlight
        :showFilterTime = showFilterTime
        :showGoBackButton = showGoBackButton
        :showPDFButton = showPDFButton
        :showCSVButton = showCSVButton
        :hideSearchSection = hideSearchSection
        :downloadCsvFileName = downloadCsvFileName
        :lmListActions = lmListActions
        :enablePreloadFiltering = enablePreloadFiltering
        :preloadFilterArguments = preloadFilterArguments
        />
      <LmButton
        v-if="enableGoBackButton"
        type="button"
        buttonClass="btn-secondary"
        :value="$t('go_back')"
        @click.native="goBackBtn"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        />
      <LmButton
        v-if="!enableGoBackButton"
        type="button"
        buttonClass="btn-secondary"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        />
      <div v-if="!enableGoBackButton" class="d-inline-flex align-items-center ml-1">
        <LmButton
          type="submit"
          buttonClass="btn-primary"
          :isProcessing="formIsProcessing"
          value="Crear Remito"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          :disabled="selectedItemsCount === 0 || selectedItemsCount > 100"
          @click.native="submit"
          />
        <small v-if="tableItemsTotal > 100" class="text-muted ml-2">
          Hay más de 100 expedientes en el resultado. El remito se va a crear con los 100 expedientes que se ven en la página.
        </small>
      </div>
      <b-alert :show="showWarningAlert" variant="warning">
        Lo sentimos pero un remito solo puede tener 100 expedientes. Por favor modifique los filtros e intente nuevamente.
      </b-alert>
    </LmForm>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmForm from '@/components/form/LmForm.vue'
import LmTableCustom from '@/components/LmTableCustom'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import { EventBus } from '@/event-bus.js'

export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmForm,
    LmButton,
    LmTableCustom,
    LmDateTime,
    LmDate,
    LmSuperPowerSelect
  },
  data () {
    const ahora = new Date()
    const fechaDesde = moment(ahora).format('YYYY-MM-DD')
    const fechaHasta = moment(ahora).format('YYYY-MM-DD')
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      isLoading: true,
      lmSuperPowerSelects: {
        oficina: {
          selectOptions: [],
          tbColumns: [
            { title: 'Oficina', data: 'name' }
          ]
        }
      },
      form: {
        oficinaOrigen: null,
        idOficinaOrigen: null,
        oficinaDestino: null,
        idOficinaDestino: null,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta
      },
      formIsProcessing: false,
      // table
      componentKey: 0,
      hideSearchSection: true,
      order: ['desc', 'asc'],
      orderBySetting: ['fecha_movimiento'],
      searchOnFields: [],
      perPageSetting: [5, 10, 15, 20, 50, 100],
      defaultItemsPerPage: 100,
      limitExportFromClient: 10000,
      showFilterTime: true,
      apiCallPath: `pases/for_remito/`,
      showCSVButton: false,
      showGoBackButton: false,
      showPDFButton: false,
      downloadCsvFileName: '',
      lmListActions: [],
      highlight: {},
      enablePreloadFiltering: true,
      preloadFilterArguments: {
        dateFrom: fechaDesde,
        dateUpTo: fechaHasta,
        idOficinaOrigen: -1,
        idOficinaDestino: null
      }
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail', 'tableItems', 'tableItemsTotal']),
    selectedItemsCount: function () {
      const items = Array.isArray(this.tableItems) ? this.tableItems : []
      return items.filter(i => i.lmChecked).length
    },
    lmDateConfigFrom: function () {
      return {
        maxDate: this.form.fechaHasta || this.lmDateConfigUpTo.maxDate
      }
    },
    lmDateConfigUpTo: function () {
      return {
        maxDate: 'today'
      }
    },
    showWarningAlert: function () {
      return this.selectedItemsCount > 100
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    onCancelDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  validations: {
    form: {
      // Atributos Comunes
      oficinaOrigen: {
        required
      },
      oficinaDestino: {
        required
      },
      fechaDesde: {
        required
      },
      fechaHasta: {
        required
      }
    }
  },
  watch: {
    'form.fechaDesde': function () {
      this.preloadFilterArguments.dateFrom = this.form.fechaDesde
    },
    'form.fechaHasta': function () {
      this.preloadFilterArguments.dateUpTo = this.form.fechaHasta
    },
    'form.oficinaOrigen': function () {
      this.preloadFilterArguments.idOficinaOrigen = this.form.idOficinaOrigen
    },
    'form.oficinaDestino': function () {
      this.preloadFilterArguments.idOficinaDestino = this.form.idOficinaDestino
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.push(this.onCancelDestinationRoute)
    },
    cancelBtn () {
      if (this.$v.form.$invalid) {
        this.$router.push(this.onCancelDestinationRoute)
      } else {
        if (confirm(this.$t('cancel_msg'))) {
          this.$router.push(this.onCancelDestinationRoute)
        }
      }
    },
    async submit () {
      try {
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        /**
         * Se persisten los datos
         */
        const tableItems = Array.isArray(this.tableItems) ? this.tableItems : []
        let saveData = {
          transacciones: tableItems.filter(i => i.lmChecked).map(i => i.hidden_ntransac),
          fechaDesde: this.form.fechaDesde,
          fechaHasta: this.form.fechaHasta,
          idOficinaOrigen: this.form.idOficinaOrigen,
          idOficinaDestino: this.form.idOficinaDestino
        }
        try {
          let response = await this.updateItemDetail({
            path: 'remitos/new/',
            data: saveData
          })
          this.formIsProcessing = false
          const h = this.$createElement
          let vNodesMsg
          if (response.id) {
            vNodesMsg = h(
              'p',
              { },
              response.id.map(idRemito => {
                return h('router-link', {
                  props: {
                    to: `/remitos/detail/${idRemito}`
                  }
                }, `Remito: ${idRemito} `)
              })
            )
            EventBus.$emit('lmShowGlobalToast', {
              toastMessage: [vNodesMsg],
              toastAttributes: {
                title: response.id.length > 1 ? 'Nuevos Remitos' : 'Nuevo Remito',
                toaster: 'b-toaster-bottom-center',
                variant: 'success',
                solid: true
              }
            })
          }

          this.$router.push(this.onSuccessDestinationRoute)
        } catch (error) {
          this.formIsProcessing = false
          if (error.response && error.response.status === 400) {
            this.$bvToast.toast(error.response.data.message, {
              title: 'Error',
              toaster: 'b-toaster-bottom-center',
              variant: 'danger',
              solid: true
            })
          } else {
            this.$bvToast.toast(this.$t('try_again_later'), {
              title: 'Error',
              toaster: 'b-toaster-bottom-center',
              variant: 'danger',
              solid: true
            })
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    updateOficinaOrigen (values) {
      const isThereValue = values.length
      const value = values[0]
      this.form.idOficinaOrigen = isThereValue ? value.id : ''
      this.form.oficinaOrigen = isThereValue ? value.name : ''
    },
    updateOficinaDestino (values) {
      const isThereValue = values.length
      const value = values[0]
      this.form.idOficinaDestino = isThereValue ? value.id : ''
      this.form.oficinaDestino = isThereValue ? value.name : ''
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    }
  },
  created () {
    (async () => {
      // Se obtiene el ID de oficina del usuario logeado
      const userInfo = await this.getUserInfo()
      this.form.idOficinaOrigen = userInfo.extra.c_oficina
      const allLmSuperPowerSelectOptions = await this.getAllLmSuperPowerSelectOptions([
        {
          name: 'oficina',
          obj: {
            path: 'oficinas/predictivo/',
            total: 1000
          }
        }
      ])
      allLmSuperPowerSelectOptions.forEach(async element => {
        const e = await element
        this.lmSuperPowerSelects[e.name].selectOptions = e.data
      })
      this.isLoading = false
    })()
  }
}
</script>
